<template>
  <div>
    <el-dialog
      title="调拨商品"
      :visible.sync="Allotvisible"
      width="70%"
      append-to-body
      :before-close="handleClose"
    >
      <div style="margin-bottom: 40px">
        <el-table
          :data="Allot_list"
          border
          stripe
          style="width: 100%"
          tooltip-effect="dark"
        >
          <el-table-column align="center" label="商品封面" width="120">
            <template slot-scope="scope"
              ><img :src="scope.row.cover" alt="" height="50px" width="50px" />
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="商品名称"
            width="160"
            prop="commodityName"
          ></el-table-column>
          <el-table-column
            align="center"
            label="商品规格"
            width="120"
            prop="commoditSpecifications"
          ></el-table-column>

          <el-table-column
            align="center"
            label="仓库当前库存"
            width="120"
            prop="quantityStock"
            v-if="userInfo.username != 'admin'"
          ></el-table-column>

          <el-table-column
            align="center"
            label="接收仓库"
            width="200"
            prop="targetEntrepotId"
            v-if="userInfo.username != 'admin'"
          >
            <template slot-scope="{ row }">
              <el-select
                class="cus_width"
                v-model="row.targetEntrepotId"
                clearable
                placeholder="选择接收仓库"
              >
                <el-option
                  :label="item.name"
                  :value="item.id"
                  v-for="(item, index) in storeEntList"
                  :key="index"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            label="调拨数量"
            width="140"
            prop="quantity"
          >
            <template slot-scope="{ row }">
              <el-input v-model="row.quantity"></el-input>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            label="备注"
            min-width="200"
            prop="quantity"
          >
            <template slot-scope="{ row }">
              <el-input
                v-model="row.remark"
                type="textarea"
                :rows="2"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            prop="icon"
            width="160"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                plain
                @click="sumbitDiaoBuButton(scope.row, scope.$index)"
                >调拨提交</el-button
              ></template
            ></el-table-column
          >
        </el-table>
        <el-pagination
          :current-page="Allot_total.pageNo"
          :page-size="Allot_total.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="Allot_total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleDuSizeChange"
          @current-change="handleDuCurrentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      Allot_list: [],
      Allotvisible: false,
      Allot_total: 0,
      storeEntList: [],
      userInfo: {},
      Allot_Form: {
        pageNo: 1,
        pageSize: 10,
        entrepotId: "",
      },
    };
  },
  created() {},
  methods: {
    getUserInfo() {
      this.$axios.post("/admin/user/userInfo").then((res) => {
        this.userInfo = res.data;
      });
    },
    handleDuCurrentChange(val) {
      this.Allot_Form.pageNo = val;
      this.getStash();
    },
    handleDuSizeChange(val) {
      this.Allot_Form.pageSize = val;
      this.getStash();
    },
    getEntrepots() {
      this.$axios.get("/admin/entrepot/getEntrepots", {}).then((res) => {
        this.storeEntList = res.data;
      });
    },
    sumbitDiaoBuButton(row, index) {
      if (row.targetEntrepotId) {
        if (row.quantityStock < row.quantity) {
          this.$message({
            showClose: true,
            message: "库存不足，无法调拨",
            type: "error",
            onClose: () => {},
          });
          return false;
        }
      }
      this.Allot_Form.index = index;
      this.submitdiaobuForm(row);
    },
    submitdiaobuForm(row) {
      var obj = {
        quantity: row.quantity,
        sourceEntrepotId:
          this.Allot_Form.type == 1 && this.userInfo.username == "admin"
            ? null
            : this.Allot_Form.id,
        targetEntrepotId:
          this.Allot_Form.type == 1 && this.userInfo.username == "admin"
            ? this.Allot_Form.id
            : row.targetEntrepotId,
        remark: row.remark,
        commoditSpecificationsId: row.commoditSpecificationsId,
      };
      this.$axios.post("/admin/entrepotCommodity/dispatch", obj).then((res) => {
        this.$message({
          showClose: true,
          message: "恭喜你，提交成功",
          type: "success",
          onClose: () => {},
        });
      });
    },
    getStash() {
      this.$axios
        .get(
          "/admin/entrepotCommodity/getDispatchCommodityList?pageNo=" +
            this.Allot_Form.pageNo +
            "&pageSize=" +
            this.Allot_Form.pageSize +
            "&entrepotId=" +
            this.Allot_Form.entrepotId,
          {}
        )
        .then((res) => {
          this.Allot_list = res.data.records;
          this.Allot_total = res.data.total;
          this.getEntrepots();
        });
    },

    init(row) {
      this.Allot_Form = {
        pageNo: 1,
        pageSize: 10,
        entrepotId: row.type == 1 ? "" : row.id,
        id: row.id,
        type: row.type,
        index: null,
      };
      this.getStash();
      this.getEntrepots();
      this.getUserInfo();
      this.Allotvisible = true;
    },
    handleClose() {
      this.Allotvisible = false;
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
.cus_area {
  margin: 10px;
}
</style>
